import { DateRange } from "@src/components/Filter";

export type CQView = "enCours" | "tousEnCours" | "tous";

export type CQFilters = {
  pipelineStages: string[];
  millesimes: number[];
  dateDebut: DateRange;
  dateDepot: DateRange;
  dateFin: DateRange;
};

export const EMPTY_FILTERS: CQFilters = {
  pipelineStages: [],
  millesimes: [],
  dateDebut: {},
  dateDepot: {},
  dateFin: {},
};

export type CQListState = {
  page: number;
  sortBy: string;
  sortOrder: "asc" | "desc" | undefined;
  search: string;
  view: CQView;
  appliedFilters: CQFilters;
};

export const DEFAULT_CQ_LIST_STATE: CQListState = {
  page: 1,
  sortBy: "dateDebut",
  sortOrder: "desc",
  search: "",
  view: "enCours",
  appliedFilters: EMPTY_FILTERS,
};

const STORAGE_KEY = "cq-list-state";

type PersistedCQListState = Omit<CQListState, "sortOrder"> & {
  sortOrder: "asc" | "desc" | null;
};

export const loadCQListState = (): CQListState => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_CQ_LIST_STATE;
    const parsed = JSON.parse(raw) as Partial<PersistedCQListState>;
    return {
      ...DEFAULT_CQ_LIST_STATE,
      ...parsed,
      sortOrder:
        parsed.sortOrder === null
          ? undefined
          : (parsed.sortOrder ?? DEFAULT_CQ_LIST_STATE.sortOrder),
      appliedFilters: {
        ...EMPTY_FILTERS,
        ...parsed.appliedFilters,
      },
    };
  } catch {
    return DEFAULT_CQ_LIST_STATE;
  }
};

export const saveCQListState = (state: CQListState) => {
  const persisted: PersistedCQListState = {
    ...state,
    sortOrder: state.sortOrder ?? null,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(persisted));
};
